module.exports = __webpack_public_path__ + "img/scripted.f2a86a45.svg";